import { render, staticRenderFns } from "./rcgyysq.vue?vue&type=template&id=15c4b754&scoped=true&"
import script from "./rcgyysq.vue?vue&type=script&lang=js&"
export * from "./rcgyysq.vue?vue&type=script&lang=js&"
import style0 from "./rcgyysq.vue?vue&type=style&index=0&id=15c4b754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4b754",
  null
  
)

export default component.exports